export default {
  MESSAGING: "in-app-messaging",
  AI_DOCTYPE_DETECTION_AND_EXTRACTION: "ai-doctype-detection-and-extraction",
  PENDO_TRACKING: "pendo-tracking",
};
